<template>
<kt-row v-if="status === 'setFormData'">
    <kt-col xs="12">
        <form @submit.prevent="edit">
            <kt-form-group>
                <kt-form-label for="wage">
                    {{ $t('label.change_wage') }} ({{ $t('label.rial') }})
                </kt-form-label>
                <kt-form-control
                        id="wage"
                        name="wage"
                        v-model="pardakht_shakhsi.wage"
                >
                </kt-form-control>
            </kt-form-group>
            <kt-form-action class="mt-4">
                <button class="btn btn-md btn-success btn-wide" type="submit" id="change_wage_btn">
                    {{ $t('btn.edit') }}
                </button>
            </kt-form-action>
        </form>
    </kt-col>
</kt-row>
</template>

<script>
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { mapGetters } from 'vuex'
import { pardakhtShakhsiService } from '@/common/api.service'

export default {
    computed: {
        ...mapGetters('pardakhtShakhsi', {
            pardakht_shakhsi: 'form_data',
            status: 'status'
        }),
    },
    methods: {
        edit(e) {
            let btn = $('#change_wage_btn')
            KTApp.progress(btn)

            pardakhtShakhsiService.changeWage(this.pardakht_shakhsi.id, this.pardakht_shakhsi.wage).then(response => {
                this.showMsg($('#setting_col'), 'success', response.data.message)
            })

            setTimeout(() => {
                KTApp.unprogress(btn)
            }, 1000)
        }
    },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>